function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import { withStyles } from "@material-ui/styles";

import red from "@material-ui/core/colors/red";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FileUpload from "@material-ui/icons/CloudUpload";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";

import Dropzone from "react-dropzone";

import FileGrid from "../../components/FileGrid/FileGrid";

import { removeItemArray } from "../../utils/arrayUtils";

import download from "../../utils/download";
import upload from "../../utils/upload";
import PhotoGalleryModal from "../../components/FileGrid/PhotoGalleryModal";
import FileGridItem from "../../components/FileGrid/FileGridItem";

var convertFilesUploadToFormDinamicoFiles = function convertFilesUploadToFormDinamicoFiles(files) {
  return files.map(function (file) {
    file.length = file.size;
    file.link = file.preview;

    return file;
  });
};

var styles = function styles(_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    actions: {
      display: "flex",
      alignItems: "center",
      marginTop: "10px"
    },
    button: {
      margin: spacing(),
      "&:first-child": {
        marginLeft: 0
      }
    },
    rightIcon: {
      marginLeft: spacing()
    }
  };
};

var MultipleUploadWidget = function (_Component) {
  _inherits(MultipleUploadWidget, _Component);

  function MultipleUploadWidget() {
    var _temp, _this, _ret;

    _classCallCheck(this, MultipleUploadWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      accepted: Array.isArray(_this.props.formData) ? [].concat(_this.props.formData) : [],
      loading: false,
      error: false,
      openPhotoGallery: false
    }, _this.handleDeleteClick = function (file, index) {
      var onChange = _this.props.onChange;


      _this.setState(function (state) {
        var array = removeItemArray(state.accepted, index);

        onChange(array);
        return { accepted: array };
      });
    }, _this.handleUploadFiles = function (accepted) {
      var onChange = _this.props.onChange;

      var config = _this.getUploadConfig();
      var originalAcceptedFiles = [].concat(_this.state.accepted);

      _this.setState(function () {
        return {
          accepted: [].concat(originalAcceptedFiles, convertFilesUploadToFormDinamicoFiles(accepted)),
          loading: true
        };
      });

      var promises = accepted.map(function (acceptedFile) {
        return upload(config, acceptedFile);
      });

      Promise.all(promises).then(function (values) {
        var allFiles = [].concat(originalAcceptedFiles, values).filter(function (elem, pos, arr) {
          return arr.indexOf(elem) === pos;
        });

        _this.setState(function () {
          return {
            accepted: allFiles,
            loading: false,
            error: false
          };
        });

        onChange(allFiles);
      }, function (error) {
        console.error("Erro ao fazer o upload", error);
        _this.setState({
          error: error,
          accepted: originalAcceptedFiles,
          loading: false
        });
      });
    }, _this.handleOpenPhotoGallery = function () {
      _this.setState({ openPhotoGallery: true });
    }, _this.handleCancelPhotoGallery = function () {
      _this.setState({ openPhotoGallery: false });
    }, _this.handleConfirmPhotoGallery = function (selectedsPhotos) {
      var onChange = _this.props.onChange;


      _this.setState(function (state) {
        var allFiles = [].concat(state.accepted, selectedsPhotos).filter(function (elem, pos, arr) {
          return arr.indexOf(elem) === pos;
        });

        //TODO: verificar se vai funcionar
        onChange && onChange(selectedsPhotos);

        return {
          accepted: allFiles,
          openPhotoGallery: false
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MultipleUploadWidget.prototype.handleDownloadClick = function handleDownloadClick() {
    var uiSchema = this.props.uiSchema;
    var headers = uiSchema["ui:options"].headers;


    return function (file) {
      return download(file, headers);
    };
  };

  MultipleUploadWidget.prototype.getUploadConfig = function getUploadConfig() {
    var uiSchema = this.props.uiSchema;


    return uiSchema["ui:options"].upload;
  };

  MultipleUploadWidget.prototype.renderFileList = function renderFileList() {
    var _this2 = this;

    var accepted = this.state.accepted;


    return React.createElement(
      "div",
      { style: { marginTop: "15px" } },
      React.createElement(FileGrid, {
        files: accepted,
        render: function render(file, index) {
          return React.createElement(FileGridItem, {
            key: index,
            index: index,
            file: file,
            onFileClick: _this2.handleDownloadClick,
            onActionClick: _this2.handleDeleteClick,
            actionIcon: React.createElement(DeleteIcon, { style: { color: "#fff" } })
          });
        }
      })
    );
  };

  MultipleUploadWidget.prototype.renderError = function renderError() {
    return React.createElement(
      "p",
      { style: { margin: "15px 0 0" } },
      React.createElement(
        Typography,
        { component: "span", style: { color: red["A400"] } },
        "Ocorreu um erro ao fazer o upload"
      )
    );
  };

  MultipleUploadWidget.prototype.renderUpload = function renderUpload() {
    var _this3 = this;

    var _state = this.state,
        loading = _state.loading,
        openPhotoGallery = _state.openPhotoGallery;
    var _props = this.props,
        classes = _props.classes,
        schema = _props.schema,
        uiSchema = _props.uiSchema,
        formData = _props.formData;

    var gallery = uiSchema["ui:options"].customProps || [];

    return React.createElement(
      "div",
      { className: classes.actions },
      Boolean(gallery.length) && React.createElement(
        Button,
        {
          className: classes.button,
          variant: "raised",
          color: "default",
          onClick: this.handleOpenPhotoGallery,
          disabled: loading
        },
        "Galeria",
        React.createElement(PhotoLibraryIcon, { className: classes.rightIcon })
      ),
      React.createElement(
        Button,
        {
          color: "default",
          onClick: function onClick() {
            _this3.dropzoneRef.open();
          },
          disabled: schema.disabled || loading
        },
        "Upload",
        React.createElement(FileUpload, { className: classes.rightIcon })
      ),
      loading && React.createElement(CircularProgress, { className: classes.progress }),
      React.createElement(Dropzone, {
        ref: function ref(node) {
          _this3.dropzoneRef = node;
        },
        onDrop: this.handleUploadFiles,
        style: { visibility: "hidden" }
      }),
      openPhotoGallery && React.createElement(PhotoGalleryModal, {
        open: openPhotoGallery,
        selecteds: formData,
        gallery: gallery,
        onCancel: this.handleCancelPhotoGallery,
        onConfirm: this.handleConfirmPhotoGallery
      })
    );
  };

  MultipleUploadWidget.prototype.render = function render() {
    var schema = this.props.schema;
    var _state2 = this.state,
        error = _state2.error,
        accepted = _state2.accepted;


    return React.createElement(
      "section",
      null,
      React.createElement(
        FormControl,
        { component: "fieldset" },
        React.createElement(
          FormLabel,
          { component: "legend" },
          schema.title + (schema.required ? " *" : "")
        )
      ),
      React.createElement(
        FormGroup,
        null,
        this.renderUpload(),
        error && this.renderError(),
        Boolean(accepted.length) && this.renderFileList()
      )
    );
  };

  return MultipleUploadWidget;
}(Component);

MultipleUploadWidget.defaultProps = {
  formData: []
};

export default withStyles(styles)(MultipleUploadWidget);